module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_500000_1000000.fee2b69c.png";